import { SPECIALTY_GROUPS } from "../../data/site";

export const SpecialtyFilter = ({ active, onChange, count }) => (
    <div data-testid="specialty-filter" className="mt-8">
        <p className="mb-3 text-xs uppercase tracking-[0.18em] text-amber-200/45">
            Find a therapist by specialty
        </p>
        <div className="flex flex-wrap gap-2">
            {[{ key: null, label: "Everyone" }, ...SPECIALTY_GROUPS].map((g) => {
                const on = active === g.key;
                return (
                    <button
                        key={g.key || "all"}
                        type="button"
                        data-testid={`specialty-chip-${g.key || "all"}`}
                        aria-pressed={on}
                        onClick={() => onChange(g.key)}
                        className={`rounded-full border px-4 py-2 text-sm transition-[background-color,color,border-color,transform] duration-200 active:scale-95 ${
                            on
                                ? "border-amber-400 bg-amber-400 text-[#1F1510]"
                                : "border-amber-500/25 bg-amber-500/5 text-amber-100/75 hover:border-amber-400/60 hover:text-amber-50"
                        }`}
                    >
                        {g.label}
                    </button>
                );
            })}
        </div>
        {active && (
            <p data-testid="specialty-result-count" className="mt-3 text-sm text-amber-100/55">
                {count} {count === 1 ? "therapist" : "therapists"} with this focus
            </p>
        )}
    </div>
);
